import React from "react";
import { NavLink } from "react-router-dom";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import Cta from "../../components/cta/cta";
import KeyFeatBanner from "../../assets/images/key-features/key-feat.png";
import salesTriggers from "../../assets/images/key-features/sales-triggers.png";
import orgChart from "../../assets/images/key-features/org-chart.png";
import directDials from "../../assets/images/key-features/directDials.png";
import reportAnalysis from "../../assets/images/key-features/report-analysis.png";

const KeyFeaturesPage = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";

  return (
    <>
      <div className="keyFeat-wrapper">
        <section className="keyFeat-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    <span className="text-primary-color">Automate</span> the{" "}
                    <br /> Boring Stuff, Close <br /> the Fun{" "}
                    <span
                      className="text-primary-color"
                      style={{ fontStyle: "italic" }}
                    >
                      Deals
                    </span>
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Automate your outreach, analyze performance, and never{" "}
                    <br /> miss an opportunity with real-time triggers.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Get Started
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={KeyFeatBanner}
                    className="img-responsive position-relative"
                    alt="Automate the Boring Stuff, Close the Fun Deals"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section>
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Get More Done, While Doing Less
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridTemplateColumns,
                  "--grid-gap": "24px",
                }}
              >
                <div
                  className="common-shadow common-box keyFeatPoints"
                  style={{ backgroundColor: "#F7F6FD" }}
                >
                  <img
                    src={orgChart}
                    loading="lazy"
                    class="img-responsive position-relative mb20"
                    alt="Organizational Chart"
                  />
                  <h3 className="roboto-bold heading20px mb20">
                    Organizational Chart
                  </h3>

                  <ul class="points-ul">
                    <li class="heading16px roboto-regular">
                      Visualize your entire organization at a glance, empowering
                      smarter business decisions.
                    </li>
                    <li class="heading16px roboto-regular">
                      {" "}
                      Map relationships, drive alignment, and unlock the full
                      potential of your workforce.
                    </li>
                  </ul>
                </div>

                <div
                  className="common-shadow common-box keyFeatPoints"
                  style={{ backgroundColor: "#EEF9FF" }}
                >
                  <img
                    src={directDials}
                    loading="lazy"
                    class="img-responsive position-relative mb20"
                    alt="Direct Dials & Emails"
                  />
                  <h3 className="roboto-bold heading20px mb20">
                    Direct Dials & Emails
                  </h3>

                  <ul class="points-ul">
                    <li class="heading16px roboto-regular">
                      Connect instantly with decision-makers—no barriers, just
                      results.
                    </li>
                    <li class="heading16px roboto-regular">
                      Boost conversions with verified contact details at your
                      fingertips.
                    </li>
                  </ul>
                </div>

                <div
                  className="common-shadow common-box keyFeatPoints"
                  style={{ backgroundColor: "#F7FFF8" }}
                >
                  <img
                    src={reportAnalysis}
                    loading="lazy"
                    class="img-responsive position-relative mb20"
                    alt="Report & Analysis"
                  />
                  <h3 className="roboto-bold heading20px mb20">
                    Report & Analysis
                  </h3>

                  <ul class="points-ul">
                    <li class="heading16px roboto-regular">
                      Turn data into actionable insights that drive performance
                      and growth.
                    </li>
                    <li class="heading16px roboto-regular">
                      Uncover trends and optimize strategies with detailed,
                      real-time reporting.
                    </li>
                  </ul>
                </div>

                <div
                  className="common-shadow common-box keyFeatPoints"
                  style={{ backgroundColor: "#EEEFFF" }}
                >
                  <img
                    src={salesTriggers}
                    loading="lazy"
                    class="img-responsive position-relative mb20"
                    alt="Sales Triggers"
                  />
                  <h3 className="roboto-bold heading20px mb20">
                    Sales Triggers
                  </h3>

                  <ul class="points-ul">
                    <li class="heading16px roboto-regular">
                      Never miss an opportunity—stay ahead with real-time sales
                      alerts.
                    </li>
                    <li class="heading16px roboto-regular">
                      Capitalize on key moments with instant notifications that
                      fuel engagement.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default KeyFeaturesPage;
